import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/apps/blogtostart/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/root/apps/blogtostart/node_modules/next/dist/client/app-dir/link.js");
